import React, { useEffect, useState } from 'react';
import SC_ManageData from '../SC_ManageData'; 

function BlockSumFooter({store}) {

  /************ SETTING ************** */
  const [inputData, setInputData] = useState('');
  const [settings, setCartSettings] = useState(store.getState().sidecartsettings.appSettings || null);
  const [sumimage, setSumImageSettings] = useState(store.getState().checkoutsettings.checkoutSettings?.cartsummary_image || null);
  const [sumtext, setSumImageText] = useState(store.getState().checkoutsettings.checkoutSettings?.cartsummary_text || null);
  //const currency = store.getState().sidecartsettings.appSettings.currency;
  const currency = store.getState().generalsettings.generalSettings.currency;

 /************ METACART ************** */
  const [totalformat, setTotalFormat] = useState(store.getState().shoppingcart.metacartdata?.[0]?.totalpriceformat || '');
  const [totalprice, setTotalPrice] = useState(store.getState().shoppingcart.metacartdata?.[0]?.totalprice || '');
  const [alltaxes, setAllTaxesPrice] = useState(store.getState().shoppingcart.metacartdata?.[0]?.alltaxes || '');
  const [alltaxlabels, setAllTaxLabelsPrice] = useState(store.getState().shoppingcart.metacartdata?.[0]?.alltaxlabels || '');

   /************ SELECTED ************** */
  const [shippingData, setShippingData] = useState(store.getState().selectedorderdata.shippingdata || '');
  const [shippingprice, setShippingPrice] = useState(store.getState().selectedorderdata.shippingdata?.pricewithtax || '');
  const [shipordeliver, setShipOrDeliver] = useState(store.getState().selectedorderdata?.shipordeliverdata || '');


  

  


  //console.log("Shippingprice: ",shippingprice);





const getRelativeCheckoutURL = () => {
  const checkoutPath = '/kasse/'; // Der Pfad zur Kasse
  const checkoutURL = settings.base_url + checkoutPath; // Die relative URL zur Kasse
  return checkoutURL;
};


useEffect(() => {
  const unsubscribe = store.subscribe(() => {
    setShippingData(store.getState().selectedorderdata.shippingdata || '');
    setShipOrDeliver(store.getState().selectedorderdata.shipordeliverdata || '');
 
  });

  return () => {
    unsubscribe();
  };
}, []);


useEffect(() => {
  //console.log('Shipping data changed:', shippingData);
  setShippingPrice(store.getState().selectedorderdata.shippingdata?.pricewithtax || '');
  // Hier kannst du auf die Änderung von shippingData reagieren
}, [shippingData]);




  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    try {
      const response = await fetch(getRelativeCheckoutURL(), {
        method: 'POST',
        body: formData,
      });
      if (!response.ok) {
        throw new Error('Fehler beim Absenden des POST-Requests');
      }
      window.location.href = getRelativeCheckoutURL();
    } catch (error) {
      console.log('Fehler: ' + error.message);
    }
  };


  useEffect(() => {

    const updateStore = () => {

    
      const metacartdata = store.getState().shoppingcart.metacartdata;
      if (metacartdata && metacartdata.length > 0) {
        setTotalFormat(metacartdata[0].totalpriceformat);
        setTotalPrice(metacartdata[0].totalprice);
        setAllTaxesPrice(metacartdata[0].alltaxes);
        setAllTaxLabelsPrice(metacartdata[0].alltaxlabels);
      }
    };
        // Redux Store abonnieren
  const unsubscribe = store.subscribe(updateStore);


  return () => {

    unsubscribe();
  };
}, []);

  
  const buttonToCheckout = () => {
    return (
      <form onSubmit={handleSubmit} action={serverURL} method="POST">
        <input
          type="text"
          name="data"
          value={inputData}
          onChange={(e) => setInputData(e.target.value)}
        />
        <button type="submit">Daten senden</button>
      </form>
    );
  };


  




  //const serverURL = 'https://buecherbuechse.de'; // Oder die entsprechende Server-URL
  const serverURL = getRelativeCheckoutURL();


  return (
    <>
      <div className="row p-2 mx-0 ips-sidecart-elementfooter">
        <div className="ips-sidecart-footer">
          <div className="col-12 p-0" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div className="row p-0 flex-grow-1">
              
            <div id="ips-alert-placeholder">
		        <div class="ips-alert">
			      <div class="message"></div>
		        </div>
	          </div>

  
      
		


  
  
  
  
  </div>
            <div className="row p-2 flex-grow-0"> 
            <div className="col-6 p-0">Zwischensumme:</div><div className="col-3 p-0"></div><div className="col-3 p-0 text-center" dangerouslySetInnerHTML={{ __html: totalformat !== 0 ? totalformat : "" }}></div>
            </div>
            <div className="row p-2 flex-grow-0"> 
            <div className="col-6 p-0">Versand:</div><div className="col-3 p-0"></div><div className="col-3 p-0 text-center" dangerouslySetInnerHTML={{ __html: shippingprice !== 0 &&  shippingprice !== "" && shipordeliver !== "pickup" ? (parseFloat(shippingprice)).toFixed(2) +" "+ currency : "Kostenlos!" }}></div>
            </div>
            <div className="row p-2 flex-grow-0 ips-checkout-order-total"> 
            <div className="col-6 p-0 ips-checkout-totalsummary-price">Gesamtsumme:</div><div className="col-3 p-0"></div><div className="col-3 p-0 text-center ips-checkout-totalsummary-price" dangerouslySetInnerHTML={{ __html: shippingprice !== 0 &&  shippingprice !== "" && shipordeliver !== "pickup" ? (parseFloat(totalprice) + parseFloat(shippingprice)).toFixed(2) +" "+ currency : (parseFloat(totalprice)).toFixed(2) +" "+ currency }}></div>
            </div>





            <div>
    {Object.keys(alltaxlabels).map(taxClassId => (
        <div key={taxClassId} className="row p-2 flex-grow-0"> 
            <div className="col-6 p-0 ips-tax-totals-info">inkl. {alltaxlabels[taxClassId]}</div>
            <div className="col-3 p-0"></div>
            <div className="col-3 p-0 text-center ips-tax-totals-info" dangerouslySetInnerHTML={{ __html: alltaxes[taxClassId] !== 0 && alltaxes[taxClassId] !== "" ? alltaxes[taxClassId] +" "+ currency : "Kostenlos!" }}></div>
        </div>
    ))}
</div>


{/*
            <div className="row p-2 flex-grow-0"> 
            <div className="col-6 p-0">inkl. 19 % MwSt.</div><div className="col-3 p-0"></div><div className="col-3 p-0 text-center" dangerouslySetInnerHTML={{ __html: shippingprice !== 0 &&  shippingprice !== "" ? shippingprice +" "+ currency : "Kostenlos!" }}></div>
            </div>
            <div className="row p-2 flex-grow-0"> 
            <div className="col-6 p-0">inkl. 7 % MwSt.</div><div className="col-3 p-0"></div><div className="col-3 p-0 text-center" dangerouslySetInnerHTML={{ __html: shippingprice !== 0 &&  shippingprice !== "" ? shippingprice +" "+ currency : "Kostenlos!" }}></div>
            </div>
  */}


            <div className="row p-2 pb-3 flex-grow-0 "> 
          
            </div>


            <div id="ips_trust_badges" className="ips-module ips-trust-badges-position-below_cart_summary">



            <div id="ips_trust_badges" className="ips-module ips-trust-badges-position-below_cart_summary">
      <div className="ips-trust-badges">
        <div className="ips-badge row">
          <div className="col-3">
            {/* Bild nur anzeigen, wenn sumimage vorhanden ist */}
            {sumimage ? (
              <img
                width="110"
                height="64"
                src={sumimage}
                className="attachment-ips_trust_badge_thumb size-ips_trust_badge_thumb"
                alt="Trust Badge"
                decoding="async"
                srcSet={sumimage}
                sizes="(max-width: 110px) 100vw, 110px"
              />
            ) : null}
          </div>
          <div className="col-9 ips-checkout-small">
            {/* Text nur anzeigen, wenn sumtext vorhanden ist */}
            {sumtext ? (
              <>
                <h5>{sumtext}</h5>
                <p></p> {/* Optionaler Platz für weiteren Text */}
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>




{/*
        <div className="ips-trust-badges">
          <div className="ips-badge row">
            <div className="col-3">
            <img width="110" height="64" src={sumimage} className="attachment-ips_trust_badge_thumb size-ips_trust_badge_thumb" alt="" decoding="async" srcSet={sumimage} sizes="(max-width: 110px) 100vw, 110px" />
            </div>
            <div className="col-9 ips-checkout-small">
              <h5>Wir legen Wert auf Nachhaltigkeit!</h5>
              <p></p>
            </div>
          </div>
        </div>
*/}




      </div>

            
            <div className="row g-0 p-0 flex-grow-0">
              <div className="ips-proceed-to-checkout">

              {/*buttonToCheckout()*/}
        
             
              
       
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockSumFooter;